import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionsGuard } from '@core/guard/permissions.guard';
import { PageViewConfigPresorteoComponent } from './page-view-config-presorteo/page-view-config-presorteo.component';

const routes: Routes = [
  {
    path: '',
    component: PageViewConfigPresorteoComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['core.view-config.get'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesViewConfigCoreRoutingModule { }
